import { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './Temoignages.css';

import imgBoulangerie from '../../assets/vitrine/Boulangerie.png';
import imgCoiffure from '../../assets/vitrine/coiffure.png';
import imgJardinage from '../../assets/vitrine/jardinage.png';
import imgNaturophate from '../../assets/vitrine/naturophate.png';

const projects = [
  {
    title: 'Site vitrine — boulangerie',
    category: 'Site Web',
    year: '2025',
    img: imgBoulangerie,
  },
  {
    title: 'Site vitrine — coiffure',
    category: 'Site Web',
    year: '2025',
    img: imgCoiffure,
  },
  {
    title: 'Site vitrine — jardinage',
    category: 'Site Web',
    year: '2024',
    img: imgJardinage,
  },
  {
    title: 'Site vitrine — naturophate',
    category: 'Site Web',
    year: '2024',
    img: imgNaturophate,
  },
];

export default function Temoignages() {
  const [lightbox, setLightbox] = useState(null);

  const closeLightbox = useCallback(() => setLightbox(null), []);

  useEffect(() => {
    if (!lightbox) return;
    const onKey = (e) => {
      if (e.key === 'Escape') closeLightbox();
    };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [lightbox, closeLightbox]);

  const lightboxEl =
    lightbox &&
    createPortal(
      <div
        className="tpf__lightbox"
        role="presentation"
        onClick={closeLightbox}
      >
        <div
          className="tpf__lightbox-inner"
          role="dialog"
          aria-modal="true"
          aria-labelledby="tpf-lightbox-title"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            className="tpf__lightbox-close"
            onClick={closeLightbox}
            aria-label="Fermer l’aperçu"
          >
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
          <img
            className="tpf__lightbox-img"
            src={lightbox.src}
            alt={lightbox.title}
          />
          <p id="tpf-lightbox-title" className="tpf__lightbox-caption">
            {lightbox.title}
          </p>
        </div>
      </div>,
      document.body
    );

  return (
    <>
      <section className="tpf" id="temoignages">
        <div className="tpf__bg-dots" />

        <div className="tpf__inner">

          {/* ── Header row ── */}
          <div className="tpf__toprow">
            <h2 className="tpf__title">
              <span className="tpf__title-main">ILS NOUS ONT</span>
              <span className="tpf__title-sub">FAIT CONFIANCE</span>
            </h2>
            <div className="tpf__nav">
              <button className="tpf__nav-btn" aria-label="Précédent">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="18" height="18">
                  <path d="M15 18l-6-6 6-6"/>
                </svg>
              </button>
              <button className="tpf__nav-btn" aria-label="Suivant">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="18" height="18">
                  <path d="M9 18l6-6-6-6"/>
                </svg>
              </button>
            </div>
          </div>

          {/* ── Grid 2×2 ── */}
          <div className="tpf__grid">
            {projects.map((p, i) => (
              <div className="tpf__card" key={i}>

                {/* Image / placeholder */}
                <div
                  className="tpf__card-img"
                  style={{
                    background: p.img
                      ? `url(${p.img}) center/cover no-repeat`
                      : p.bg,
                  }}
                >
                  {/* Overlay hover */}
                  <div className="tpf__card-overlay">
                    <button
                      type="button"
                      className="tpf__card-view"
                      disabled={!p.img}
                      aria-label={`Agrandir l’aperçu : ${p.title}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (p.img) setLightbox({ src: p.img, title: p.title });
                      }}
                    >
                      VIEW
                    </button>
                  </div>

                  {/* Placeholder si pas d'image */}
                  {!p.img && (
                    <div className="tpf__placeholder">
                      <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="1" width="56" height="56">
                        <rect x="2" y="3" width="20" height="14" rx="2"/>
                        <path d="M8 21h8M12 17v4"/>
                      </svg>
                      <span>Ajoute ton screenshot ici</span>
                    </div>
                  )}
                </div>

                {/* Infos sous la carte */}
                <div className="tpf__card-info">
                  <p className="tpf__card-title">{p.title}</p>
                  <div className="tpf__card-meta">
                    <span className="tpf__card-cat">{p.category}</span>
                    <span className="tpf__card-year">{p.year}</span>
                  </div>
                </div>

              </div>
            ))}
          </div>

        </div>
      </section>
      {lightboxEl}
    </>
  );
}
